import { motion } from "framer-motion";
import { Compass } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const Vision = () => {
  const { t } = useLang();

  return (
    <section
      id="vision"
      data-testid="vision-section"
      className="relative overflow-hidden bg-[#050507] py-24 md:py-32 lg:py-40"
    >
      <div className="absolute right-0 top-24 h-px w-1/3 bg-gradient-to-l from-[#00F0FF]/40 to-transparent" />
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.65, ease: [0.22, 1, 0.36, 1] }}
          className="grid gap-8 lg:grid-cols-[0.72fr_1.28fr] lg:gap-20"
        >
          <div>
            <div className="inline-flex h-11 w-11 items-center justify-center border border-[#00F0FF]/25 bg-[#00F0FF]/5 text-[#00F0FF]">
              <Compass className="h-5 w-5" aria-hidden="true" />
            </div>
            <p className="mt-7 font-mono text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">
              {t.vision.overline}
            </p>
          </div>
          <h2
            data-testid="vision-heading"
            className="max-w-4xl font-heading text-4xl font-medium tracking-tight text-white sm:text-5xl lg:text-6xl"
          >
            {t.vision.title}
          </h2>
        </motion.div>

        <div className="mt-16 border-t border-white/10 md:mt-20">
          {t.vision.directions.map((direction, index) => {
            return (
              <motion.article
                key={direction.title}
                data-testid={`vision-direction-${index + 1}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.15 }}
                transition={{ duration: 0.55, delay: index * 0.06, ease: [0.22, 1, 0.36, 1] }}
                className="group grid gap-6 border-b border-white/10 py-10 md:grid-cols-[72px_minmax(0,1fr)] md:gap-8 lg:gap-12"
              >
                <div className="font-mono text-xs tracking-[0.18em] text-[#00F0FF]">
                  0{index + 1}
                </div>
                <div className="grid gap-6 md:grid-cols-[182px_minmax(0,1fr)] md:items-center md:gap-10">
                  <div className="min-w-0 md:col-start-2 md:row-start-1">
                    <h3 data-testid={`vision-direction-title-${index + 1}`} className="font-heading text-2xl font-medium tracking-tight text-[#00F0FF]">
                      {direction.title}
                    </h3>
                    <p data-testid={`vision-direction-slogan-${index + 1}`} className="mt-4 font-heading text-base font-medium leading-relaxed text-zinc-200">
                      {direction.slogan}
                    </p>
                  </div>
                  <figure data-testid={`vision-direction-image-${index + 1}`} className="aspect-[3/2] w-[70%] max-w-none justify-self-start overflow-hidden border border-white/10 bg-[#0A0A0E] md:col-start-1 md:row-start-1 md:w-full md:max-w-[182px]">
                    <img src={direction.image} alt="" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  </figure>
                </div>
              </motion.article>
            );
          })}
        </div>

      </div>
    </section>
  );
};